import wixWindow from "wix-window";
import wixSite from "wix-site";
import wixLocation from "wix-location";
import { fetch } from "wix-fetch";
import { local } from "wix-storage";

const CLIENT_ID_STORAGE_KEY = "CLIENT_ID";

export function setClientId(val) {
  const currVal = getClientId();
  if (!currVal || currVal !== val) {
    local.setItem(CLIENT_ID_STORAGE_KEY, val);
  }
}

export function getClientId() {
  return local.getItem(CLIENT_ID_STORAGE_KEY);
}

export function trackClickEvent(clickObj, redirectUrl='') {
  const obj = {
		uniqueId: clickObj.uniqueId,
		label: clickObj.label,
		name: clickObj.id,
		type: clickObj.type.split('.')[1],
		linkTo: redirectUrl,
		url: `${wixLocation.baseUrl}/${wixLocation.path}`,
	}
	const route = `https://app.wixanswers.com/api/bi/website-click?uniqueId=${obj.uniqueId}&type=${obj.type}&name=${obj.name}&url=${obj.url}&label=${obj.label}&linkTo=${obj.linkTo}`;
	

	$w('#clickEventContainer').postMessage(route);
  setTimeout(() => {
		wixLocation.to(redirectUrl)
	},100);
}

export class Bi {
  constructor() {
    if (instance) {
      return instance;
    }
    let instance;

    this.state = {
      client_id: getClientId(),
      page_url: wixSite.currentPage.url,
      referral_name: wixLocation.query.referral,
      referral_url: wixWindow.referrer,
      page_name: wixLocation.path.join("/"),
      user_id: ""
    };

    this.events = [117, 118, 119, 120, 121, 122, 124, 125, 126];

    instance = this;
    this.changeState = this.changeState.bind(this);
    this.logState = this.logState.bind(this);
    this.sendEvent = this.sendEvent.bind(this);
    this.urlEncodeEventData = this.urlEncodeEventData.bind(this);
  }

  changeState(newState) {
    this.state = Object.assign({}, this.state, newState);
  }

  logState() {
    const t = this;
    console.log(t.state);
  }

  urlEncodeEventData() {
    const t = this;
    return encodeURI(
      Object.entries(t.state)
        .map(item => `${item[0]}=${item[1]}`)
        .join("&")
    );
  }

  sendEvent(evid) {
    if (!this.events.includes(evid)) {
      return new Promise((_, reject) => {
        reject("Invalid event");
      });
    }

    const baseUrl = "https://frog.wix.com/wix-answers?src=77&evid=";
    const eventUrl = `${baseUrl}${evid}&${this.urlEncodeEventData()}`;
    const fetchOptions = {
      cache: "no-store",
      method: "GET",
      credentials: "include"
    };

    const { query } = wixLocation;
    if (query.isSantaEditor === "true") {
      return new Promise(resolve => {
        console.log(`Dev mode detected. Would send: ${eventUrl}`);
        resolve();
      });
    }

    return fetch(eventUrl, fetchOptions).then(res => res.status);
  }
}
